import { apiClient, Auth } from '@/shared/api'

import { TRoomOptions } from '../model/schema'

export type RoomOptionsParams = {
  roomId: number
}

export const getRoomOptions = async ({ roomId }: RoomOptionsParams) => {
  const response = await apiClient.get<TRoomOptions>({
    endpoint: `/host/rooms/${roomId}/options`,
    auth: Auth.REQUIRED,
  })

  return response
}
